import { Box, Text } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const FloatingDomain = _ref => {
  let {
    datahook
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    textAlign: "center",
    padding: "SP5 SP2 SP3 SP2",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    transform: "translateY(-8px)",
    backgroundColor: "#F7F5F3",
    dataHook: datahook
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, t('domains_search_gate.logged_in.mobile.domain_floating.message')));
};
//# sourceMappingURL=FloatingDomain.js.map